import { JepGraphic } from '@jeppesen-foreflight/jmkw-types';
import { NavigationFeatureType } from '../navigation-feature-type';
import { AmdbAttributes } from './amdb-attributes';
import { FeatureDetail } from './feature-detail';
import * as stringUtils from '../../../../utilities/string-format.utils';
import { AmdbAttributesRaw } from './amdb-attributes-raw';

export class Amdb implements FeatureDetail {
  id: string;
  navType: NavigationFeatureType = 'amdb';
  attributes: AmdbAttributes;

  constructor(public graphic: JepGraphic) {
    this.id = this._getId(graphic?.attributes);
    this.attributes = this._formatAttributes(graphic?.attributes);
  }

  private _getId(attrs?: AmdbAttributesRaw): string {
    return stringUtils.formatString(attrs?.runwayident);
  }

  private _formatAttributes(attrs?: AmdbAttributesRaw): AmdbAttributes {
    if (!attrs) {
      return {
        airportId: '',
        id: '',
        magneticBearing: stringUtils.formatBearing(0),
        isClosed: false,
        length: '',
        lightPosition: '',
        surfaceMaterial: '',
        touchdownZoneElevation: '',
        width: ''
      };
    }

    return {
      airportId: stringUtils.formatString(attrs.airporteid),
      id: stringUtils.formatString(attrs.runwayident),
      magneticBearing: stringUtils.formatBearing(attrs.bearingmagnetic),
      isClosed: Boolean(attrs.isclosed),
      length: stringUtils.formatMeasurement(attrs.length, 'm'),
      lightPosition: stringUtils.formatString(attrs.lightposition),
      surfaceMaterial: stringUtils.formatString(attrs.surfacematerial),
      touchdownZoneElevation: stringUtils.formatMeasurement(
        attrs.touchdownzoneelevation,
        'ft'
      ),
      width: stringUtils.formatMeasurement(attrs.width, 'm')
    };
  }
}
